/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Filter_ActionsInputs */

const en_common_filter_actions = /** @type {(inputs: Common_Filter_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter actions`)
};

/**
* | output |
* | --- |
* | "Filter actions" |
*
* @param {Common_Filter_ActionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_filter_actions = /** @type {((inputs?: Common_Filter_ActionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Filter_ActionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_filter_actions(inputs)
});